<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0" v-on:keypress.enter.prevent="getFactoryTable(1)">
                    <multiselect
                        v-model="search.factory"
                        class="form-control select border-0"
                        placeholder="ค้นหาสินค้าโรงงาน"
                        :options="optionFactory"
                        :show-labels="false"
                        :customLabel="factoryLabel"
                        track-by="id">
                    </multiselect>
                    <button @click="getFactoryTable(1)"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>&nbsp
                    <button class="btn btn-warning my-2 my-sm-0"
                            @click="createFactoryData"
                            type="button">
                        <icon name="plus"></icon>
                        เพิ่มสินค้าโรงงาน
                    </button>&nbsp;
                </form>
            </div>
        </nav>

        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">นำเข้าสินค้าโรงงาน</th>
                    <th scope="col">นำออกสินค้าโรงงาน</th>
                    <th scope="col">รหัสสินค้าโรงงาน</th>
                    <th scope="col">ชื่อสินค้าโรงงาน</th>
                    <th scope="col">จำนวนคงเหลือ</th>
                    <th scope="col">ราคาขาย/หน่วย</th>
                    <th scope="col">วันที่อัพเดตล่าสุด</th>
                    <th scope="col">แก้ไข/ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in factoryTable">
                    <td>
                        <a @click="showFactoryData(data.id,'import')">
                            <img src="@/assets/plus_icon.png" width="40px"/>
                        </a>
                    </td>
                    <td>
                        <a @click="showFactoryData(data.id,'export')">
                            <img src="@/assets/delete_icon.png" width="40px"/>
                        </a>
                    </td>
                    <td>{{data.code}}</td>
                    <td>{{data.name}}</td>
                    <td>{{data.quantity ? data.quantity : 0}}</td>
                    <td>{{data.price}}</td>
                    <td>{{data.updated_at | moment('DD/MM/YYYY')}}</td>
                    <td>
                        <a @click="showFactoryData(data.id,'edit')">
                            <icon name="pencil-alt"></icon>
                        </a>
                        &nbsp;&nbsp;
                        <a @click="showDeleteModal(data.id)">
                            <icon name="trash-alt"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <vue-pagination :pagination="dataPaginate"
                        @paginate="getFactoryTable(dataPaginate.current_page)">
        </vue-pagination>
        <b-modal hide-footer hide-header ref="import_item">
            <factory-import-modal @submit="ImportFactoryItem">
            </factory-import-modal>
        </b-modal>
        <b-modal hide-footer hide-header ref="export_item">
            <factory-export-modal @submit="ExportFactoryItem">
            </factory-export-modal>
        </b-modal>
        <b-modal hide-header hide-footer ref="delete_item">
            <delete-confirm-modal @submit="deleteFactoryData"></delete-confirm-modal>
        </b-modal>
        <b-modal hide-header hide-footer ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import FactoryImportModal from "./FactoryImportModal";
    import FactoryExportModal from "./FactoryExportModal";
    import VuePagination from "../Pagination";
    import DeleteConfirmModal from "../Utility/DeleteConfirmModal";
    import Loading from "../Utility/Loading";
    import moment from "moment";
    import Multiselect from "vue-multiselect";

    export default {
        name: "factory-list",
        components: {Loading, DeleteConfirmModal, VuePagination,
            Multiselect,
            FactoryExportModal, FactoryImportModal},
        computed:{
            ...mapState({
                form : state=>{
                    return state.FactoryEmployee.form
                },
                importForm : state=>{
                    return state.FactoryEmployeeImport.form
                },
                exportForm : state=>{
                    return state.FactoryEmployeeExport.form
                },
                user : state=>{
                    return state.Auth.user;
                },
            })
        },
        created() {
            this.getFactoryTable(1);
            this.getFactoryEmployeeAll();
        },
        data(){
            return{
                optionFactory : [],
                optionEmployee : [],
                msg : '',
                status_loading : 1,
                search : {
                    factory : '',
                    employee : '',
                },
                delete_id : '',
                factoryTable:[],
                dataPaginate:{
                    current_page :1,
                    from : 1,
                    last_page : 1,
                    per_page : 1,
                    total : 1,
                    to : 1
                }
            }
        },
        methods:{
            factoryLabel(option){
                return `${option.code} - ${option.name}`
            },
            showDeleteModal(id){
                this.delete_id = id;
                this.$refs.delete_item.show();
            },
            hideDeleteModal(){
                this.$refs.delete_item.hide();
            },
            showLoadingModal(){
                this.$refs.loading.show();
            },
            hideLoadingModal(){
                this.$refs.loading.hide();
            },
            showImportItemModal(){
                this.$refs.import_item.show();
            },
            hideImportItemModal(){
                this.$refs.import_item.hide();
            },
            showExportItemModal(){
                this.$refs.export_item.show();
            },
            hideExportItemModal(){
                this.$refs.export_item.hide();
            },
            getFactoryEmployeeAll(){
                this.$store.dispatch('FactoryEmployee/getFactoryEmployeeAll').then(res=>{
                    this.optionFactory = res;
                })
            },
            getEmployeeAll(){
              this.$store.dispatch("Employee/getEmployeeAll").then(res=>{
                  this.optionEmployee = res;
              })
            },
            getFactoryTable(page){
                let data = {
                    factory_id : this.search.factory ? this.search.factory.id : '',
                }
                this.$store.dispatch("FactoryEmployee/getFactoryEmployee", {
                    page ,
                    data,
                }).then(res=>{
                    this.factoryTable = res.data;
                    this.dataPaginate = {
                        current_page :res.current_page,
                        from : res.from,
                        last_page : res.last_page,
                        per_page : res.per_page,
                        total : res.total,
                        to : res.to
                    }
                })
            },
            createFactoryData(){
                this.$store.dispatch("FactoryEmployee/clearFormDataFactoryEmployee").then(()=>{
                    this.goToFactoryForm();
                })
            },
            showFactoryData(id,action){
                this.msg = 'กรุณารอสักครู่';
                this.status_loading = 1;
                this.showLoadingModal();
                this.$store.dispatch("FactoryEmployee/showFactoryEmployee",id).then(res=>{
                    if(res){
                        this.$store.dispatch("FactoryEmployee/setFormFactoryEmployee",res).then(()=>{
                            if(action == 'import'){
                                this.$store.dispatch("FactoryEmployeeImport/clearFormDataFactoryEmployeeImport");
                                this.importForm.factory = res;
                                this.importForm.hr_factory_id = res.id;
                                this.importForm.user_id = this.user.id;
                                this.hideLoadingModal();
                                this.showImportItemModal();
                            }else if(action == 'export'){
                                this.$store.dispatch("FactoryEmployeeExport/clearFormDataFactoryEmployeeExport");
                                this.exportForm.factory = res;
                                this.exportForm.hr_factory_id = res.id;
                                this.exportForm.user_id = this.user.id;
                                this.hideLoadingModal();
                                this.showExportItemModal()
                            }else{
                                this.goToFactoryForm();
                            }
                        });
                    }else{
                        alert('ไม่มีข้อมูลสินค้าโรงงาน');
                    }
                })
            },
            goToFactoryForm(){
                this.$router.push("/factory-form");
            },
            ImportFactoryItem(value){
                if(value){
                    let data = {
                        employee_id : value.employee_id,
                        date : value.date ? moment(value.date).format("YYYY-MM-DD") : '',
                        hr_factory_id : value.hr_factory_id,
                        quantity : value.quantity,
                        user_id : value.user_id
                    }
                    this.$store.dispatch("FactoryEmployeeImport/saveFactoryEmployeeImport", {
                        id : '',
                        data,
                    }).then(res=>{
                        if(res){
                            this.goToImportTable();
                        }else{
                            alert("นำออกสินค้าโรงงานไม่เสร็จ");
                        }
                    }).catch(()=>{
                        alert("นำเข้าสินค้าโรงงานไม่เสร็จ");
                    })
                }
                this.hideImportItemModal();
            },
            ExportFactoryItem(value){
                if(value){
                    let data = {
                        employee_id : value.employee_id,
                        date : value.date ? moment(value.date).format("YYYY-MM-DD") : '',
                        hr_factory_id : value.hr_factory_id,
                        quantity : value.quantity,
                        user_id : value.user_id
                    }
                    this.$store.dispatch("FactoryEmployeeExport/saveFactoryEmployeeExport", {
                        id : '',
                        data,
                    }).then(res=>{
                        if(res){
                            this.goToExportTable();
                        }else{
                            alert("นำออกสินค้าโรงงานไม่เสร็จ");
                        }
                    }).catch(()=>{
                        alert("นำออกสินค้าโรงงานไม่เสร็จ");
                    })
                }
                this.hideExportItemModal();
            },
            goToImportTable(){
                this.$router.push("/import-factory-product");
            },
            goToExportTable(){
                this.$router.push("/export-factory-product");
            },
            deleteFactoryData(value){
                if(value && this.delete_id){
                    this.msg = 'กรุณารอสักครู่';
                    this.status_loading = 1;
                    this.showLoadingModal();
                    this.$store.dispatch("FactoryEmployee/deleteFactoryEmployee",this.delete_id).then(()=>{
                        this.getFactoryTable(this.dataPaginate.current_page);
                        this.msg = 'ลบรายการสำเร็จ';
                        this.status_loading = 2;
                        this.showLoadingModal();
                    }).catch(()=>{
                        this.msg = 'ลบรายการไม่สำเร็จ';
                        this.status_loading = 3;
                        this.showLoadingModal();
                    })
                }
                this.hideDeleteModal();
            }
        },
    }
</script>

<style scoped>

</style>
